import { useId } from 'react'

import { Label, SearchSelect } from '@fortem-monorepo/react-ui'
import { getErrorMessage } from '@fortem-monorepo/web-sdk'

import { useAccruedChartInstruments } from '@/react-query/queries/accrued-interests'

import { useAccruedInterestsContext } from '../AccruedInterests.context'

export const AccruedChartInstrumentFilter = ({ disabled }: { disabled: boolean }) => {
  const { params, chartInstrumentId, setChartInstrumentId } = useAccruedInterestsContext()
  const query = useAccruedChartInstruments({ fund_name: params.fund_name })
  const id = useId()
  return (
    <>
      <div className="space-y-1">
        <Label htmlFor={id}>ISIN</Label>
        <SearchSelect
          id={id}
          size="sm"
          placeholder="Select an ISIN"
          loading={query.isFetching}
          disabled={disabled || !params.fund_name || !query.data?.length}
          options={(query.data ?? []).map((instrument) => ({
            value: String(instrument.instrument_id),
            label: instrument.isin,
          }))}
          value={chartInstrumentId ? String(chartInstrumentId) : ''}
          setValue={(value) => setChartInstrumentId(Number(value))}
        />
      </div>
      {query.isError && (
        <p role="alert" className="text-sm text-destructive">
          Unable to load ISINs. {getErrorMessage(query.error)}
        </p>
      )}
      {params.fund_name && query.isSuccess && !query.data.length && (
        <p className="text-sm text-muted-foreground">No saved balances with an ISIN for this fund.</p>
      )}
    </>
  )
}
